import React from 'react'
import { isMobile } from 'react-device-detect'

import GenericRow from '../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import {
  SUB_tile,
  PromoInfo,
  SUB_ball,
} from '../style/SelectSubscriptionPlanScreenStyle'
import GenericCloseButton from '../../../GenericComponents/GenericCloseButton'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { BsArrowLeftShort, BsCheck, BsX } from 'react-icons/bs'

import GenericButton from '../../../GenericComponents/GenericButton'

const Nutshell = ({
  promoInfo,
  onSelectSubscription,
  nutshellVersion,
}: any) => {
  const [isInfoOpen, setInfoOpen] = React.useState(false)
  const [isInfoOpen1, setInfoOpen1] = React.useState(false)

  return (
    <GenericRow
      width={'100%'}
      flexDir={isMobile ? 'column' : 'row'}
      justify={nutshellVersion.length ? 'center' : 'space-between'}
      margin={'2% 0 0 0'}
    >
      {/* #a1ff68 */}
      {!nutshellVersion.includes('vol. 2') && (
        <SUB_tile>
          <GenericRow width={'100%'} justify={'left'} margin={'3% 0 0 0'}>
            {/* <div className="new-badge presell">
              <span>PRZEDSPRZEDAŻ</span>
            </div> */}
            <GenericTextSpan fSize={'1.5rem'} color={'white'} fWeight={'bold'}>
              MIAZGA w pigułce vol. 1
            </GenericTextSpan>
          </GenericRow>
          <GenericTextSpan
            margin={'1% 0 0 0'}
            tAlign="left"
            fSize={'1rem'}
            color={'white'}
            fWeight={''}
          >
            3 miesiące
          </GenericTextSpan>

          <GenericTextSpan
            margin={'3% 0 0 0'}
            tAlign={'right'}
            width={'100%'}
            display="block"
            fSize={'1.5rem'}
            color={'#a1ff68'}
          >
            {((promoInfo && promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
              (promoInfo &&
                promoInfo.promo_status ==
                  'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')) && (
              <GenericTextSpan
                position="absolute"
                right="25px"
                top="5px"
                color={'#a1ff68'}
                fSize={'1.2rem'}
                className="crossed"
              >
                {' '}
                249,99
              </GenericTextSpan>
            )}
            zł
          </GenericTextSpan>
          <GenericTextSpan
            margin={'3% 0 0 0'}
            tAlign={'right'}
            width={'100%'}
            display="block"
            fSize={'3rem'}
            color={'#a1ff68'}
          >
            {(promoInfo && promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
            (promoInfo &&
              promoInfo.promo_status == 'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
              ? '149,99'
              : '249,99'}
          </GenericTextSpan>
          {/* <GenericRow width={'50%'} alignSelf={'end'} color={'#a1ff68'}> */}
          <GenericTextSpan fSize={'1rem'} tAlign={'right'} color={'#a1ff68'}>
            Jednorazowa płatność
          </GenericTextSpan>
          {/* </GenericRow> */}

          <GenericTextSpan
            margin={'3% 0 0 0'}
            tAlign={'center'}
            width={'100%'}
            display="block"
            fSize={'1.3rem'}
            color={'white'}
            fWeight="bold"
          >
            KUP TERAZ AKTYWUJ W DOWOLNYM MOMENCIE
          </GenericTextSpan>

          <GenericRow
            // onClick={() => setInfoOpen(true)}
            margin={'3% 0'}
            color={'#a1ff68'}
          >
            <AiOutlineInfoCircle
              onClick={() => setInfoOpen(true)}
              // className="miazga-info"
            />
            <GenericTextSpan
              margin={'0% 0 0 1%'}
              tAlign={'left'}
              width={'100%'}
              fSize={'1rem'}
              color={'#a1ff68'}
              fWeight="bold"
              onClick={() => setInfoOpen1(true)}
            >
              Sprzęt potrzebny do ćwiczeń
            </GenericTextSpan>

            {isInfoOpen1 && (
              <div className="miazga-nutshell-info nutshell">
                <GenericCloseButton
                  className="promo-modal-close-btn info "
                  width={'14px'}
                  height={'14px'}
                  onClick={() => setInfoOpen1(false)}
                />
                <GenericTextSpan
                  display={'block'}
                  fSize={'1.3rem'}
                  fWeight="bold"
                  color={'white'}
                  tAlign={'center'}
                >
                  Potrzebny sprzęt:
                </GenericTextSpan>
                <ul>
                  <li>hantle</li>
                  <li>gumy</li>
                  <li>hip band</li>
                  <li>mata</li>
                  <li>krzesło</li>
                </ul>
              </div>
            )}
          </GenericRow>

          <GenericRow
            justify="start"
            margin={isMobile ? '15% 0 0 0' : '6% 0 0 0'}
          >
            <SUB_ball color={'#601c69'}>
              <BsX className="fill-white-icon" />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Treningi MIAZGA
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#a1ff68'}>
              <BsCheck />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              MIAZGA w pigułce vol. 1
            </GenericTextSpan>
          </GenericRow>

          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#601c69'}>
              <BsX className="fill-white-icon" />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Wyzwanie szpagat
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#a1ff68'}>
              <BsCheck />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Panel diety
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#a1ff68'}>
              <BsCheck />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Kalkulator kalorii
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#a1ff68'}>
              <BsCheck />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Plan picia wody
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#601c69'}>
              <BsX className="fill-white-icon" />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Działy tematyczne
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#a1ff68'}>
              <BsCheck />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Rozgrzewka, technika i rozciąganie
            </GenericTextSpan>
          </GenericRow>

          <GenericRow margin={'3% 0 0 0'}>
            <GenericButton
              onClick={() => onSelectSubscription('nutshell1')}
              justify={'center'}
              className="standard"
            >
              Zamów
            </GenericButton>
          </GenericRow>
        </SUB_tile>
      )}

      {((nutshellVersion && nutshellVersion.includes('vol. 2')) ||
        !nutshellVersion) && (
        <SUB_tile>
          <GenericRow width={'100%'} justify={'left'} margin={'3% 0 0 0'}>
            <GenericTextSpan fSize={'1.5rem'} color={'white'} fWeight={'bold'}>
              MIAZGA w pigułce vol. 2
            </GenericTextSpan>
          </GenericRow>
          <GenericTextSpan
            margin={'1% 0 0 0'}
            tAlign="left"
            fSize={'1rem'}
            color={'white'}
            fWeight={''}
          >
            3 miesiące
          </GenericTextSpan>

          <GenericTextSpan
            margin={'3% 0 0 0'}
            tAlign={'right'}
            width={'100%'}
            display="block"
            fSize={'1.5rem'}
            color={'#a1ff68'}
          >
            {((promoInfo && promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
              (promoInfo &&
                promoInfo.promo_status ==
                  'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')) && (
              <GenericTextSpan
                position="absolute"
                right="25px"
                top="5px"
                color={'#a1ff68'}
                fSize={'1.2rem'}
                className="crossed"
              >
                {' '}
                249,99
              </GenericTextSpan>
            )}
            zł
          </GenericTextSpan>
          <GenericTextSpan
            margin={'3% 0 0 0'}
            tAlign={'right'}
            width={'100%'}
            display="block"
            fSize={'3rem'}
            color={'#a1ff68'}
          >
            {(promoInfo && promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
            (promoInfo &&
              promoInfo.promo_status == 'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
              ? '149,99'
              : '249,99'}
          </GenericTextSpan>
          {/* <GenericRow width={'50%'} alignSelf={'end'} color={'#a1ff68'}> */}
          <GenericTextSpan fSize={'1rem'} tAlign={'right'} color={'#a1ff68'}>
            Jednorazowa płatność
          </GenericTextSpan>
          {/* </GenericRow> */}

          <GenericTextSpan
            margin={'3% 0 0 0'}
            tAlign={'center'}
            width={'100%'}
            display="block"
            fSize={'1.3rem'}
            color={'white'}
            fWeight="bold"
          >
            KUP TERAZ AKTYWUJ W DOWOLNYM MOMENCIE
          </GenericTextSpan>

          <GenericRow
            // onClick={() => setInfoOpen(true)}
            margin={'3% 0'}
            color={'#a1ff68'}
          >
            <AiOutlineInfoCircle
              onClick={() => setInfoOpen(true)}
              // className="miazga-info"
            />
            <GenericTextSpan
              margin={'0% 0 0 1%'}
              tAlign={'left'}
              width={'100%'}
              fSize={'1rem'}
              color={'#a1ff68'}
              fWeight="bold"
              onClick={() => setInfoOpen(true)}
            >
              Sprzęt potrzebny do ćwiczeń
            </GenericTextSpan>

            {isInfoOpen && (
              <div className="miazga-nutshell-info nutshell">
                <GenericCloseButton
                  className="promo-modal-close-btn info "
                  width={'14px'}
                  height={'14px'}
                  onClick={() => setInfoOpen(false)}
                />
                <GenericTextSpan
                  display={'block'}
                  fSize={'1.3rem'}
                  fWeight="bold"
                  color={'white'}
                  tAlign={'center'}
                >
                  Potrzebny sprzęt:
                </GenericTextSpan>
                <ul>
                  <li>hantle</li>
                  <li>mata</li>
                  <li>duża piłka do ćwiczeń</li>
                  <li>gumy hip band</li>
                  <li>pas neoprenowy (nieobowiązkowe)</li>
                </ul>
              </div>
            )}
          </GenericRow>

          <GenericRow
            justify="start"
            margin={isMobile ? '15% 0 0 0' : '6% 0 0 0'}
          >
            <SUB_ball color={'#601c69'}>
              <BsX className="fill-white-icon" />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Treningi MIAZGA
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#a1ff68'}>
              <BsCheck />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              MIAZGA w pigułce vol. 2
            </GenericTextSpan>
          </GenericRow>

          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#601c69'}>
              <BsX className="fill-white-icon" />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Wyzwanie szpagat
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#a1ff68'}>
              <BsCheck />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Panel diety
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#a1ff68'}>
              <BsCheck />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Kalkulator kalorii
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#a1ff68'}>
              <BsCheck />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Plan picia wody
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#601c69'}>
              <BsX className="fill-white-icon" />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Działy tematyczne
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify="start" margin={'3% 0 0 0'}>
            <SUB_ball color={'#a1ff68'}>
              <BsCheck />
            </SUB_ball>
            <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
              Rozgrzewka, technika i rozciąganie
            </GenericTextSpan>
          </GenericRow>

          <GenericRow margin={'3% 0 0 0'}>
            <GenericButton
              onClick={() => onSelectSubscription('nutshell2')}
              justify={'center'}
              className="standard"
            >
              Zamów
            </GenericButton>
          </GenericRow>
        </SUB_tile>
      )}
    </GenericRow>
  )
}

export default Nutshell
